export default {"src":"/_next/static/media/joinNowBgMobile.e38d17d4.svg","height":146,"width":414};